import React from 'react';
import VideoManagement from '../components/admin/VideoManagement';

const Videos = () => {
  return <VideoManagement />;
};

export default Videos;
